import {Text} from "@hosttools/frontend/components";
import type {ComponentProps} from "react";
import type React from "react";
import {memo} from "react";

const Paragraph: React.FC<ComponentProps<typeof Text>> = ({ref, ...rest}) => {
    return <Text {...rest} isParagraph />;
};

export default memo(Paragraph);
